import { FC, useState, useEffect, useRef } from 'react';

type ILazyProps = Globals.BasicHTMLProps & {
    offset?: number | string; //懒加载触发距离
};

export const LazyLoad: FC<ILazyProps> = props => {
    const {
        offset = 300,
        children,
        ...rest
    } = props;

    const anchorRef = useRef<HTMLDivElement>(null);
    const [active, setActive] = useState<boolean>(false);

    useEffect(() => {
        if (!anchorRef.current) {
            return;
        }
        const ob = new IntersectionObserver(
            (entries) => {
                for (let entry of entries) {
                    if (entry.isIntersecting) {
                        const anchor = entry.target as HTMLDivElement;
                        ob.unobserve(anchor);
                        setActive(true);
                    }
                }
            },
            {
                root: null, // 相对于整个视口进行判断
                rootMargin: typeof offset === 'number' ? `${offset}px` : offset, // 元素进入视口一段距离即触发
                threshold: 0, // 元素完全进入视口时触发
            },
        );
        ob.observe(anchorRef.current as HTMLDivElement);
        return () => {
            ob.disconnect();
        }
    }, []);

    return active ? children : <div ref={anchorRef} {...rest}/>
}